import { addMonths, startOfMonth } from "date-fns";
import { RouteComponentProps } from "react-router-dom";
import Month, { generateEvents } from "./components/Month";

import { useState } from "react";
import { useAppContext } from "./AppContext";
import { FeatureCard } from "./components/FeatureCard";
import { ClinicBlockAvailabilityForDates } from "./common/ParseEventsToAvailability";
import { ClinicsEnum } from "./common/enums";

export default function HomeMarketing(props: RouteComponentProps) {
  const [demoAvailabilities] = useState<ClinicBlockAvailabilityForDates>(generateEvents());

  const app = useAppContext();

  let login = () => {
    app.signIn!(`/calendar?clinic=${ClinicsEnum.HOME}`);
  };

  return (
    <div className="tw-scroll-smooth">
      <div className="tw-min-h-[800px] md:tw-min-h-[0px] tw-relative tw-overflow-visible sm:tw-overflow-hidden">
        <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-rose-200 tw-to-blue-300 tw-opacity-50"></div>
        <div className="tw-w-48 tw-h-48 tw-absolute tw-top-10 tw-right-10 lg:tw-top-24 lg:tw-left-[50rem] tw-bg-blue-500 tw-rounded-full"></div>
        <div className="tw-w-64 tw-h-64 tw-absolute tw-top-44 tw-left-10 lg:tw-top-64 lg:tw-left-80 tw-bg-teal-300 tw-rounded-full"></div>
        <div className="tw-w-52 tw-h-52 tw-absolute tw-bottom-40 tw-right-24 md:tw-top-72 lg:tw-top-[28rem] lg:tw-left-[40rem] tw-bg-purple-300 tw-rounded-full"></div>
        <div className="">
        
          <div className="tw-relative tw-m-0 sm:tw-my-10 lg:tw-my-20 sm:tw-mx-10 lg:tw-mx-20 tw-p-5 lg:tw-p-20 tw-bg-white tw-bg-clip-padding tw-backdrop-filter tw-backdrop-blur-xl tw-bg-opacity-40 tw-border-2 tw-border-white/[.65] sm:tw-rounded-3xl tw-max-w-screen-xl tw-flex tw-flex-col md:tw-flex-row">
          
            <div className="tw-w-full md:tw-w-1/2">
              <div className="tw-space-y-2 tw-mb-10">
                <h1 className="tw-text-2xl tw-text-slate-900 tw-font-light">ASOD Scheduling</h1>
                <h2 className="tw-text-4xl tw-text-slate-900">Faster communication and scheduling with patients.</h2>
              </div>
              <p className="tw-text-slate-500">Find a time that works. Epic, Outlook, and Specialty Clinics all in one spot. Sign-up once and get an always up-to-date link to share with anyone.</p>
              <div className="tw-space-x-3">
                <button onClick={login} className="tw-bg-white hover:tw-bg-slate-100 tw-font-semibold tw-py-2 tw-px-4 tw-rounded tw-shadow-lg">
                  Sign in!
                </button>
                <div className="tw-inline">
                  <span className="tw-relative tw-inline-flex">
                    <button onClick={() => window.location.replace('#learn-more')} type="button" className="tw-inline-flex tw-items-center tw-px-4 tw-py-2 tw-text-sky-700 tw-border tw-border-sky-500 tw-rounded tw-no-underline">
                      Learn More
                    </button>
                    <span className="tw-flex tw-absolute tw-h-3tw- w-3 tw-top-0 tw-right-0 -tw-mt-1 -tw-mr-1">
                      <span className="tw-animate-ping tw-absolute tw-inline-flex tw-h-full tw-w-full tw-rounded-full tw-bg-sky-400 tw-opacity-75"></span>
                      <span className="tw-relative tw-inline-flex tw-rounded-full tw-h-3 tw-w-3 tw-bg-sky-500"></span>
                    </span>
                  </span>
                </div>
              </div>
            </div>

            <div className="tw--rotate-6 md:tw-w-[1200px] md:tw-relative md:tw-left-20 md:tw-flex md:tw-space-x-10 tw-mt-10 md:tw-mt-0 tw-mb-10">
              <Month
                isDoingFirstLoad={false}
                availabilityInfoForEachDay={demoAvailabilities}
                monthStartDate={startOfMonth(addMonths(new Date(), 1))}
                className="tw-w-[600px] tw-pointer-events-none" />

              <Month
                isDoingFirstLoad={false}
                availabilityInfoForEachDay={demoAvailabilities}
                monthStartDate={startOfMonth(addMonths(new Date(), 2))}
                className="tw-w-[600px] tw-relative tw-top-20 tw-rotate-12 tw-pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
      <div id="learn-more" className="tw-bg-gray-100 dark:tw-bg-slate-900 tw-p-12">
        <div className="tw-max-w-screen-lg tw-mx-auto">
          <div className="tw-space-y-3 tw-mb-12 dark:tw-text-slate-200">
            <h1 className="tw-font-medium tw-text-3xl tw-text-center tw-mb-0">Replace <span className="tw-underline tw-decoration-red-500/80 tw-underline-offset-2">Epic</span> + <span className="tw-underline tw-decoration-blue-500/80 tw-underline-offset-2">Outlook</span> + <span className="tw-underline tw-decoration-green-500/80 tw-underline-offset-2">Excel</span></h1>
            <h2 className="tw-font-light tw-text-xl tw-text-center tw-mb-0">It's not perfect, but it's better than what we've got</h2>
          </div>
          <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-6 tw-gap-5">
            <FeatureCard className="tw-col-span-1 md:tw-col-span-3">
              <FeatureCard.Header className="tw-text-teal-500 dark:tw-text-teal-400">
                📈 Schedule Faster
              </FeatureCard.Header>
              <FeatureCard.Body>
                Pull up your clinic schedule in under a minute from anywhere, any device, anytime. Skip Duo and Citrix.
              </FeatureCard.Body>
            </FeatureCard>

            <FeatureCard className="tw-col-span-1 md:tw-col-span-3">
              <FeatureCard.Header className="tw-text-red-500 dark:tw-text-red-400">
              🎯 Schedule Accurately
              </FeatureCard.Header>
              <FeatureCard.Body>
                Avoid double-booking by blocking availabilities in Outlook that instantly reflect on your clinic calendar.
              </FeatureCard.Body>
            </FeatureCard>

            <FeatureCard className="tw-col-span-1 md:tw-col-span-2">
              <FeatureCard.Header className="tw-text-pink-500 dark:tw-text-pink-400">
                ⭐ Specialty Clinics
              </FeatureCard.Header>
              <FeatureCard.Body>
                Stop juggling Epic and Excel spreadsheets. One link to keep track of to handle all of your clinic availability.
              </FeatureCard.Body>
            </FeatureCard>

            <div className="tw-flex tw-flex-row tw-justify-center tw-col-span-1 md:tw-col-span-2 tw-order-last md:tw-order-none">
              <img src="/images/iphone-schedule.png" alt="iPhone Schedule demo" />
            </div>

            <FeatureCard className="tw-col-span-1 md:tw-col-span-2">
              <FeatureCard.Header className="tw-text-blue-500 dark:tw-text-blue-400">
                🔗 Public Calendar
              </FeatureCard.Header>
              <FeatureCard.Body>
                Create a publicly accessible link to share with patients. Enable/disable the link for all patients at <i>any</i> time.
              </FeatureCard.Body>
            </FeatureCard>

            <FeatureCard className="tw-col-span-1 md:tw-col-span-3">
              <FeatureCard.Header className="tw-text-purple-500 dark:tw-text-purple-400">
                🔒 Secure
              </FeatureCard.Header>
              <FeatureCard.Body>
                Patient data is still securely managed via Epic (HIPAA). All authentication is through Microsoft so your data stays private and is not accessible without your permission (FERPA).
              </FeatureCard.Body>
            </FeatureCard>

            <FeatureCard className="tw-col-span-1 md:tw-col-span-3">
              <FeatureCard.Header className="tw-text-orange-500 dark:tw-text-orange-400">
                🚀 Future Features...
              </FeatureCard.Header>
              <FeatureCard.Body>
                Cancellation notifications, coordinate with other students when scheduling family, and more. Let us know what would be most helpful to you!
              </FeatureCard.Body>
            </FeatureCard>
          </div>
        </div>
      </div>
    </div>
  )
}
